import React, { useState } from 'react';
import axios from 'axios';
import Success from '../../../equipmentSurveys/components/Success';
import Submit from '../../../equipmentSurveys/components/Submit';
import BasicInfoUnitForm from '../../components/BasicInfoUnitForm';
import AdditionalBasicInfoFields from './AdditionalBasicInfoFields';
import NaturalDisasterQuestion from '../../components/NaturalDisasterQuestion';
import RenderError from '../../components/RenderError';

function BasicInfo({
  applicationData: {
    aid,
    unitOne = {},
    unitOneReceipt,
    unitTwo,
    unitTwoReceipt,
    naturalDisaster,
    disasterZipcode,
    equipment_counts: { IrrigationEngine }
  } = {},
  setApplicationData,
  initialView,
  setView
}) {
  const [numberOfUnits, setNumberOfUnits] = useState(
    unitTwo !== undefined && Object.keys(unitTwo).length > 0 ? 2 : 1
  );
  const [numberOfUnitsError, setNumberOfUnitsError] = useState('');

  let initialState = {
    aid: aid ?? '',
    unitOne: {
      purchaseDate: unitOne.purchaseDate ?? '',
      purchaseAmount: unitOne.purchaseAmount ?? 0,
      manufacturer: unitOne.manufacturer ?? '',
      model: unitOne.model ?? '',
      engineSize: unitOne.engineSize ?? '',
      fuelType1: unitOne.fuelType ?? '',
      serialNumber: unitOne.serialNumber ?? '',
      receipt: unitOneReceipt ?? '',
      equipmentDealer: unitOne.equipmentDealer ?? '',
      state: unitOne.state ?? ''
    },
    naturalDisaster: naturalDisaster ?? '0',
    zipcode: disasterZipcode ?? ''
  };

  if (unitTwo !== undefined) {
    initialState = {
      ...initialState,
      unitTwo: {
        purchaseDate: unitTwo.purchaseDate ?? '',
        purchaseAmount: unitTwo.purchaseAmount ?? 0,
        manufacturer: unitTwo.manufacturer ?? '',
        model: unitTwo.model ?? '',
        engineSize: unitTwo.engineSize ?? '',
        fuelType2: unitTwo.fuelType ?? '',
        serialNumber: unitTwo.serialNumber ?? '',
        receipt: unitTwoReceipt ?? '',
        equipmentDealer: unitTwo.equipmentDealer ?? '',
        state: unitOne.state ?? ''
      }
    };
  }

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  const handleUnitsSelect = (event) => {
    setNumberOfUnitsError('');
    const { value } = event.target;
    setNumberOfUnits(value);

    if (value > 1) {
      if (IrrigationEngine === 2) {
        setNumberOfUnitsError(
          'You have reached the maximum of 2 irrigation engine applications per year.'
        );
      } else {
        setFormData({
          ...formData,
          unitTwo: {
            purchaseDate: unitTwo !== undefined ? unitTwo.purchaseDate : '',
            purchaseAmount: unitTwo !== undefined ? unitTwo.purchaseAmount : 0,
            manufacturer: unitTwo !== undefined ? unitTwo.manufacturer : '',
            model: unitTwo !== undefined ? unitTwo.model : '',
            engineSize: unitTwo !== undefined ? unitTwo.engineSize : '',
            fuelType2: unitTwo !== undefined ? unitTwo.fuelType : '',
            serialNumber: unitTwo !== undefined ? unitTwo.serialNumber : '',
            receipt: unitTwo !== undefined ? unitTwoReceipt : '',
            equipmentDealer:
              unitTwo !== undefined ? unitTwo.equipmentDealer : ''
          }
        });
      }
    } else {
      let newFormData = formData;
      delete formData.unitTwo;
      setFormData(newFormData);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setSuccess('');
    let data = new FormData();
    data.append('aid', formData.aid);
    Object.keys(formData.unitOne).forEach((key) => {
      data.append(`unit1${key}`, formData.unitOne[key]);
    });
    if ('unitTwo' in formData) {
      Object.keys(formData.unitTwo).forEach((key) => {
        data.append(`unit2${key}`, formData.unitTwo[key]);
      });
    }
    data.append('naturalDisaster', formData.naturalDisaster);
    if ('zipcode' in formData) {
      data.append('zipcode', formData.zipcode);
    }

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_save_irrigation_basic_info',
        data
      )
      .then((res) => {
        setLoading(false);
        setErrors([]);
        setSuccess(res.data.message);
        setApplicationData(res.data.applicationData);
        setTimeout(() => setView(initialView), 1000);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  return (
    <div className="fip-equipment-survey grid u--padding-right-20">
      <div className="grid__col-xs-12">
        <div className="form__field form__field--required">
          <label className="form__label">
            How many units do you have for this application?
          </label>
          <div className="form__select form__select--lg">
            <select onChange={handleUnitsSelect} defaultValue={numberOfUnits}>
              <option value="1">One</option>
              {(aid || IrrigationEngine < 1) && <option value="2">Two</option>}
            </select>
            <RenderError error={numberOfUnitsError} />
          </div>
        </div>
        <BasicInfoUnitForm
          equipmentType={'irrigation_engine'}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
        >
          <AdditionalBasicInfoFields />
        </BasicInfoUnitForm>
        {numberOfUnits > 1 && !numberOfUnitsError && (
          <BasicInfoUnitForm
            two={true}
            equipmentType={'irrigation_engine'}
            formData={formData}
            setFormData={setFormData}
            errors={errors}
          >
            <AdditionalBasicInfoFields />
          </BasicInfoUnitForm>
        )}
        <NaturalDisasterQuestion
          formData={formData}
          setFormData={setFormData}
          errors={errors}
        />
        <Submit
          loading={loading}
          handleSubmit={handleSubmit}
          text="Save Section"
          errors={errors}
          success={success}
        />
        {success && <Success success={success} />}
      </div>
    </div>
  );
}

BasicInfo.displayName = 'BasicInfo'; // because WebPack renames the function
export default BasicInfo;
